import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login.component';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { SpinnerComponent } from '../../shared/spinner/spinner.component';
import { SharedModule } from '../../shared/shared.module';
import { SignupComponent } from './signup/signup.component';
import { HomepageComponent } from './homepage/homepage.component';
import { ImageCropperModule } from 'ngx-image-cropper';
const router: Routes = [
  { path: '', redirectTo: 'signin', pathMatch: 'full' },
  { path: "signin", component: LoginComponent },
  { path: "signup", component: SignupComponent },
  { path: "homepage", component: HomepageComponent }
];

@NgModule({
  imports: [CommonModule,SharedModule, RouterModule.forChild(router), FormsModule, ReactiveFormsModule, HttpClientModule,ImageCropperModule],
  declarations: [LoginComponent,SignupComponent, HomepageComponent]
})
export class LoginModule { }
